import Vue from "vue";
import Vuex from "vuex";
//import VueJwtDecode from "vue-jwt-decode";
import roles from "../global/roles.js";
import { setInCookies, getFromCookies } from '../helper/cookiesHelper.js'

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		token: getFromCookies('token'),
		user: (() => {
			const u = getFromCookies('user')
			return u ? JSON.parse(u) : null
		})(),
		apiUrl:
			process.env.NODE_ENV === "development"
				? "https://localhost:5001/api/"
				//: "https://fcomapitest.vyfchile.cl/api/",
		:"https://fcomapi.ventisquero.com/api/",
		loading: false,

	},
	mutations: {
		setAuth(state, payload) {
			const { accessToken, user } = payload

			setInCookies('token', accessToken)
			setInCookies('user', JSON.stringify(user))

			state.token = accessToken
			state.user = user
		},
		logout(state) {
			setInCookies('token', null)
			setInCookies('user', null)

			state.token = null
			state.user = null
		},
		setLoading(state, isLoading) {
			state.loading = isLoading;
		},
	},
	getters: {
		apiToken: (state) => {
			return state.token;
		},
		apiUrl: (state) => {
			return state.apiUrl;
		},
		/*isAdmin: (state) => {
			return state.token
				? state.token.role === roles[0]
				: false;
		},*/
		isAdmin(state) {
			return state.user ? state.user?.roles?.includes(roles[0]) : false;
		},
		isDispatcher: (state) => {
			return state.user ? state.user?.roles?.includes(roles[1]) : false;
		},
		isCommercial: (state) => {
			return state.user ? state.user?.roles?.includes(roles[2]) : false;
		},
		isCourier: (state) => {
			return state.user ? state.user?.roles?.includes(roles[3]) : false;
		},
		isMainCommercial: (state) => {
			return state.user ? state.user?.roles?.includes(roles[4]) : false;
		},
		isCommercialDispatcher: (state) => {
			return state.user ? state.user?.roles?.includes(roles[1]) && state.user?.roles?.includes(roles[2]) : false;
		},
		isOenology: (state) => {
			return state.user ? state.user?.roles?.includes(roles[5]) : false;
		},
		isQuality: (state) => {
			return state.user ? state.user?.roles?.includes(roles[6]) : false;
		},
		user: state => state.user || {},
		/*user: (state) => {
			if (state.token) {
				return {
					id: state.token?.id,
					fullName: decodeURIComponent(
						escape(state.token.name)
					),
					email: state.token.email,
					roles: state.token.role,
				};
			}
			return {};
		},*/
		qualityUrl: (state) => {
			return state.qualityUrl;
		},
		loading: (state) => {
			return state.loading;
		},
	},
});
